import React from "react";
import FormValueFieldPreview from "../form-value-field-preview/FormValueFieldPreview";
import _ from "lodash";

const FindingItemPreview = props => {
  const {item, category, size=3} = props;

  return (
    <>
      <tr>
        <th scope="row">
          <FormValueFieldPreview value={item.HallazgoId} />
        </th>
        <td>
          <FormValueFieldPreview value={category} />
        </td>
        <td>
          <FormValueFieldPreview value={item.Observacion} />
        </td>
        <td>
          <FormValueFieldPreview value={item?.images?.length} />
        </td>
      </tr>

      {item?.images?.length ? (
        <tr>
          <td colSpan="4">
            <div className="row">
              {_.map(item?.images, (image, index) => (
                <div key={index} className={`col-6 col-md-${size}`}>
                  <img src={image} alt={"Img-" + index} className="w-100" />
                </div>
              ))}
            </div>
          </td>
        </tr>
      ) : (
        <></>
      )}
    </>
  );
};

export default FindingItemPreview;
